// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"SummaryPage--keyboard_navigation_jump--jRv-L","go_back_link":"SummaryPage--go_back_link--2dHw7","answered_mult_choice":"SummaryPage--answered_mult_choice--2G-1q","img":"SummaryPage--img--3PthN","svg_check":"SummaryPage--svg_check--3rKkX","content_section":"SummaryPage--content_section--2tkz3"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/SummaryPage/SummaryPage.css
// module id = 1034
// module chunks = 0